import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { SupportDialog as View } from './view'

export const SupportDialog = {
    View: reflect({
        view: View,
        bind: {
            onFormSubmit: model.formSubmitted,
            onFormChange: model.formTouched,
            isEmailError: model.$isEmailError,
            isNickError: model.$isNickError,
            isDescriptionError: model.$isDescriptionError,
            nonInteractive: model.$interactionDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(SupportDialog.View))
